import React, { useState, useEffect } from 'react'
import { GridCell, Button } from 'common-controls/Core/index'
import _ from 'common-tools/LodashHelper'

import styles from './ViewLayout.less'

export function ViewLayoutFooter (props) {
  const { actions = [], blue, buttonlocation = '' } = props
  const color = blue ? 'blue' : 'teal'
  const align = buttonlocation !== '' ? buttonlocation : 'justify' // right, center, justify, spaced
  const [buttons, setButtons] = useState([])

  useEffect(() => {
    if (actions.length === 0) {
      setButtons([])
    } else {
      setButtons(_.map(actions, (a) => {
        const { text, ...rest } = a
        return <Button key={text} {...rest} className={styles.marginBottom0}>{text}</Button>
      }))
    }
  }, [actions])

  if (buttons.length > 0) {
    return <GridCell shrink className={`slide-pane-foot-${color} text-center ` + styles.paddingRight0}>
      <div className={styles.paddingTop10 + ' ' + styles.paddingLeft20 + ' ' + styles.paddingBottom12 + ' ' + styles.paddingRight20 + ` grid-x grid-padding-x align-${align}`}>
        {
        /* {buttons} */
          _.forEach(buttons, (button) => {
            return <div className={` cell small-3`}>{button}</div>
          })
        }
      </div>
    </GridCell>
  } else {
    return null
  }
}

export default ViewLayoutFooter
